

export const homePage = "path/Turkey_nov2018/TR04-95.jpg";
export const yearsPage = "path/Australia/AU010123.jpg";
export const themesPage = "path/Iceland2018/IS02-24.jpg";
export const countriesPage = "path/Norway_jan2020/NO03-0065.jpg";

